import React from 'react';

import type { SectorMapTypes } from '../SectorMap.types';

type Seat = SectorMapTypes.Props['sector']['seats'][number];
type Crowd = SectorMapTypes.Props['sector']['crowds'][number];
type Category = SectorMapTypes.Props['categories'][number];

export const useMapData = (seats: Seat[], crowds: Crowd[], categories: Category[]) => {
	const seatMap = React.useMemo(() => new Map(seats.map((seat) => [`${seat.seatRow}-${seat.place}`, seat])), [seats]); /*  */

	const crowdMap = React.useMemo(() => new Map(crowds.map((crowd) => [crowd.tag, crowd])), [crowds]);

	const categoryMap = React.useMemo(() => new Map(categories.map((category) => [category.categoryId, category])), [categories]);

	return { seatMap, crowdMap, categoryMap };
};
